// Central content for QuickDrop Go — easy to edit in VS Code.
import {
  ShoppingCart,
  UtensilsCrossed,
  Sparkles,
  Smartphone,
  Gift,
  MapPin,
  Wrench,
  Zap,
  Store,
  Wallet,
  ShieldCheck,
  Headset,
  Cake,
  Flower2,
  Candy,
  Heart,
  PartyPopper,
  Baby,
  Gem,
  Package,
} from "lucide-react";

export const services = [
  {
    id: "grocery",
    title: "Grocery",
    desc: "Fresh produce, pantry staples & daily essentials at your door in minutes.",
    icon: ShoppingCart,
    image:
      "https://images.unsplash.com/photo-1542838132-92c53300491e?auto=format&fit=crop&w=240&q=75",
  },
  {
    id: "food",
    title: "Food Delivery",
    desc: "Piping hot meals from the best local kitchens across Agartala.",
    icon: UtensilsCrossed,
    image:
      "https://images.unsplash.com/photo-1504674900247-0877df9cc836?auto=format&fit=crop&w=240&q=75",
  },
  {
    id: "cosmetics",
    title: "Cosmetics",
    desc: "Beauty, skincare & personal care from trusted brands.",
    icon: Sparkles,
    image:
      "https://images.unsplash.com/photo-1596462502278-27bfdc403348?auto=format&fit=crop&w=240&q=75",
  },
  {
    id: "electronics",
    title: "Electronics",
    desc: "Gadgets, accessories & repairs delivered safely and fast.",
    icon: Smartphone,
    image:
      "https://images.unsplash.com/photo-1498049794561-7780e7231661?auto=format&fit=crop&w=240&q=75",
  },
  {
    id: "gifts",
    title: "Gifts",
    desc: "Thoughtful surprises wrapped and delivered for every occasion.",
    icon: Gift,
    image:
      "https://images.unsplash.com/photo-1513885535751-8b9238bd345a?auto=format&fit=crop&w=240&q=75",
  },
  {
    id: "local",
    title: "Local Delivery",
    desc: "Send anything, anywhere within the city — quick point-to-point drops.",
    icon: MapPin,
    image:
      "https://images.unsplash.com/photo-1601924994987-69e26d50dc26?auto=format&fit=crop&w=240&q=75",
  },
  {
    id: "home",
    title: "Home Services",
    desc: "Trusted professionals for your home. Launching soon.",
    icon: Wrench,
    comingSoon: true,
  },
];

export const gifts = [
  {
    title: "Birthday Gifts",
    icon: Cake,
    image:
      "https://images.unsplash.com/photo-1530103862676-de8c9debad1d?auto=format&fit=crop&w=240&q=75",
  },
  {
    title: "Anniversary Gifts",
    icon: Heart,
    image:
      "https://images.unsplash.com/photo-1518895949257-7621c3c786d7?auto=format&fit=crop&w=240&q=75",
  },
  {
    title: "Wedding Gifts",
    icon: Gem,
    image:
      "https://images.unsplash.com/photo-1519741497674-611481863552?auto=format&fit=crop&w=240&q=75",
  },
  {
    title: "Baby Shower Gifts",
    icon: Baby,
    image:
      "https://images.unsplash.com/photo-1519689680058-324335c77eba?auto=format&fit=crop&w=240&q=75",
  },
  {
    title: "Festival Gifts",
    icon: PartyPopper,
    image:
      "https://images.unsplash.com/photo-1513151233558-d860c5398176?auto=format&fit=crop&w=240&q=75",
  },
  {
    title: "Cakes",
    icon: Cake,
    image:
      "https://images.unsplash.com/photo-1578985545062-69928b1d9587?auto=format&fit=crop&w=240&q=75",
  },
  {
    title: "Flowers",
    icon: Flower2,
    image:
      "https://images.unsplash.com/photo-1490750967868-88aa4486c946?auto=format&fit=crop&w=240&q=75",
  },
  {
    title: "Chocolates",
    icon: Candy,
    image:
      "https://images.unsplash.com/photo-1548907040-4baa42d10919?auto=format&fit=crop&w=240&q=75",
  },
  {
    title: "Teddy Bears",
    icon: Gift,
    image:
      "https://images.unsplash.com/photo-1559454403-b8fb88521f11?auto=format&fit=crop&w=240&q=75",
  },
  {
    title: "Decorations",
    icon: Sparkles,
    image:
      "https://images.unsplash.com/photo-1464349095431-e9a21285b5f3?auto=format&fit=crop&w=240&q=75",
  },
  {
    title: "Gift Hampers",
    icon: Package,
    image:
      "https://images.unsplash.com/photo-1607344645866-009c320b63e0?auto=format&fit=crop&w=240&q=75",
  },
];

export const features = [
  {
    n: "01",
    title: "Fast Delivery",
    desc: "Lightning-quick drops with live tracking so you always know where your order is.",
    icon: Zap,
  },
  {
    n: "02",
    title: "Trusted Local Stores",
    desc: "We partner only with verified, quality local businesses you already love.",
    icon: Store,
  },
  {
    n: "03",
    title: "Affordable Delivery",
    desc: "Transparent, low delivery fees with no surprise charges at checkout.",
    icon: Wallet,
  },
  {
    n: "04",
    title: "Secure Payments",
    desc: "Bank-grade encryption keeps every transaction safe and private.",
    icon: ShieldCheck,
  },
  {
    n: "05",
    title: "Premium Support",
    desc: "Real humans, ready to help you 7 days a week whenever you need us.",
    icon: Headset,
  },
];

export const businessCategories = [
  "Grocery",
  "Restaurant",
  "Fast Food",
  "Cosmetics",
  "Electronics",
  "Gift Shop",
  "Pharmacy",
  "Others",
];

export const vehicleTypes = [
  "Bicycle",
  "Motorcycle",
  "Scooter",
  "Car",
  "Electric Vehicle",
];

export const contactInfo = {
  whatsapp: "+91 8837263356",
  whatsappLink: "https://wa.me/918837263356",
  email: "quickdrop1999@gmail.com",
  address: "Math Chowmuhani, Agartala, Tripura, India",
  mapEmbed:
    "https://www.google.com/maps?q=Math+Chowmuhani,+Agartala,+Tripura,+India&output=embed",
};

export const navLinks = [
  { label: "Services", href: "#services" },
  { label: "Gifts", href: "#gifts" },
  { label: "Why Us", href: "#why" },
  { label: "Partner", href: "#partner" },
  { label: "Rider", href: "#rider" },
  { label: "Contact", href: "#contact" },
];

// Update these with your real handles / Play Store link when available.
export const playStoreUrl = "";

export const socialLinks = [
  { label: "Instagram", href: "https://instagram.com" },
  { label: "Facebook", href: "https://facebook.com" },
  { label: "Twitter", href: "https://twitter.com" },
  { label: "LinkedIn", href: "https://linkedin.com" },
];

export const legalContent = {
  privacy: {
    title: "Privacy Policy",
    updated: "Last updated: 29 September 2026",
    body: [
      "About this policy: This Privacy Policy describes how QuickDrop Go handles information through its customer app, quickdropgo.in website and related delivery and support services in Agartala, Tripura, India. Contact quickdropsupport@gmail.com with privacy questions or requests.",
      "Account and contact information: We process your name, mobile number, Firebase account identifier and authentication information to sign you in, maintain your account and contact you about the service. If you provide optional profile details, such as an email address or profile image, we process those details for your profile. Phone authentication uses Firebase/Google services to verify your number and help prevent abuse.",
      "Addresses and location: We process delivery addresses, recipient contact details, landmarks and saved addresses that you provide. When you grant location permission or select a location, we use latitude and longitude to check serviceability, calculate delivery charges and help fulfil deliveries. You can manage location permission in your device or browser settings. Without a usable delivery location, some delivery features may not work.",
      "Cart, orders and payments: We process selected items, quantities, prices, order history, order status and related delivery details to manage your cart, fulfil orders and handle support requests. Payment records may include payment method, payment status and transaction references. Where online payment is available, third-party payment providers, including Razorpay, process payment information under their own privacy policies. Cash-on-delivery orders also have payment-method and status records.",
      "Technical information and notifications: The app and its service providers may process device, app or browser information, network information and diagnostic or error records needed to operate the service, prevent misuse and troubleshoot problems. Firebase Cloud Messaging uses notification tokens to deliver notifications, such as order updates. You can manage notification permissions in device settings. Browser storage is used for features such as keeping your cart and login session across visits.",
      "Support and submitted information: We process messages, enquiries and information you send to customer support to respond and resolve issues. If you submit website contact, partner or rider forms, we use the contact details, business or delivery information and documents you choose to provide to review and respond to that submission.",
      "How information is used and shared: Information is used for authentication, serviceability, order fulfilment, delivery coordination, payment handling, notifications, support and service security. Relevant order and delivery details, including customer contact information, delivery address and coordinates, may be shared with stores and assigned delivery partners as needed to fulfil an order. Technical and operational providers process information needed to provide their services. Information may also be disclosed when required by law or necessary to investigate misuse, resolve disputes or protect users and the service.",
      "Firebase and other providers: QuickDrop Go uses Google/Firebase services for functions including authentication, Firestore data storage, file storage and push notifications, and Google location/map services where available. These providers may process information on their infrastructure, which may be outside your location. Their handling of information is also explained in their respective privacy policies. Payment-provider policies apply when you use their payment services.",
      "Security: Access controls and authentication are used to limit access to customer information. No method of transmission or storage is completely secure. Protect your device and login access, and do not share OTPs with anyone, including people claiming to provide support.",
      "Retention: Information is retained as needed to operate your account and provide the service, handle support, disputes and fraud prevention, and meet applicable record-keeping obligations. The period depends on the type of information and the purpose for which it is needed; this policy does not promise a fixed retention or deletion deadline.",
      "Your choices and deletion requests: You may request access to, correction of, or deletion of your personal information, or request deletion of your QuickDrop Go account, by emailing quickdropsupport@gmail.com. State the request and the mobile number registered with your account so we can identify it. Do not send an OTP, password, payment PIN or full card details. We may need to verify ownership before acting. Some order, transaction or other records may need to be retained for legal obligations, disputes or security; we will explain relevant limitations when responding. You can also manage device permissions and edit details through available account features.",
      "Children's privacy: QuickDrop Go is intended for people able to use its ordering and delivery services responsibly, not for children using it independently. If you believe a child has supplied personal information without appropriate parent or guardian involvement, contact us so we can review the information and the appropriate action.",
      "Changes to this policy: We may update this policy as the service or its information practices change. The current version will be available at quickdropgo.in/privacy-policy with its last-updated date. Review this page for changes.",
      "Contact: QuickDrop Go, serving Agartala, Tripura, India. Website: https://quickdropgo.in. Privacy, account deletion and customer support email: quickdropsupport@gmail.com.",
    ],
  },
  terms: {
    title: "Terms & Conditions",
    updated: "Last updated: December 2025",
    body: [
      "By accessing and using the QuickDrop Go website and mobile application, you agree to be bound by these Terms & Conditions.",
      "Services: QuickDrop Go connects customers with local stores and independent delivery riders in Agartala, Tripura. Availability, delivery times and pricing may vary and are subject to change.",
      "Partner & Rider registration: Submitting a registration form does not guarantee onboarding. All applications are subject to verification and approval at our sole discretion.",
      "Acceptable use: You agree not to misuse the website, submit false information, or attempt to disrupt the service.",
      "Limitation of liability: QuickDrop Go is not liable for any indirect or consequential loss arising from the use of this website or the delivery services offered by third-party partners and riders.",
      "Contact: For any questions about these terms, email us at quickdrop1999@gmail.com.",
    ],
  },
};
